/**
 * Created by Qingger Corp.
 * User: lilong
 * Date: 2020/04/18
 * Time: 15:44
 * Desc: 店铺展示管理
 */

import { Component, Vue, Prop, Watch, Provide } from "vue-property-decorator";
import isEmpty from "lodash/isEmpty";
import { IPSService } from "@/services/ipsServices";
import { noop, numberToArray } from "@/util";
import ShopDisplayTree from "@/views/components/shopDisplayTree/shopDisplayTree";
import ShopDisplayHot from "@/views/components/newDisplayConfig/hot";
import ShopDisplayTable from "@/views/components/shopDisplayTable/shopDisplayTable";
import WindowCaseTable from "@/views/components/shopDisplayTable/shopDisplayWindow.vue";
import VideoTable from "@/views/components/shopDisplayTable/videoTable.tsx";
import { defaultImg } from "@/views/components/newDisplayConfig/shop";
import ShopDisplayOpenAd from "@/views/components/shopDisplaySketchMap/shopDisplayOpenAd";
import ShopDisplay from "@/views/components/shopDisplaySketchMap/display";

const defaultBg = "https://ssl-picture.tenyun.runsasoft.com/54200870-8371-11ea-9b4f-ef6ec191275b";

const serviceList = [() => {}, IPSService.gsPropageateList, IPSService.gsCaseList, () => {}, IPSService.gsVideoList];

@Component({
	components: {
		ShopDisplayTree,
		ShopDisplayHot,
		ShopDisplayTable,
		WindowCaseTable,
		ShopDisplayOpenAd,
		VideoTable,
		ShopDisplay,
	},
})
export default class ShopDisplayManager extends Vue {
	/**
	 * 当前页面的索引
	 * @type {string}
	 */
	public curPage = "1";

	/**
	 * 内容是否显示
	 * @type {boolean}
	 */
	public isContentBodyShow = true;

	/**
	 * 标签切换时候禁用
	 * @type {boolean}
	 */
	public isDisabled = false;

	/**
	 * 选中的标签
	 * @type {ItemObject}
	 */
	public selectNode: ItemObject = {};

	/**
	 * 商城页数据
	 * @type {ItemArray}
	 */
	public shopData: ItemArray = [];

	/**
	 * 个人中心页数据
	 * @type {ItemArray}
	 */
	public centerData: ItemArray = [];

	/**
	 * tableData搜索条件
	 * @type {ItemObject}
	 */
	public postParams: ItemObject = {};

	/**
	 * 主题
	 */
	public themeCode = null;

	/**
	 * 微页面装修数据
	 */
	public miniData: ItemArray = [];

	// 微页面基础数据
	miniPage: MiniPageBg = {
		fieldType: "miniPage",
		isActived: false,
		desc: {
			pageName: "微页面",
			val: "#f2f2f2",
			showButton: true,
			buttonInfo: {
				buttonVal: "#FCCA00",
				textColor: "#000000",
				content: "返回",
				pageInfo: {
					pageId: 0,
					page: 3,
					linkDesc: "",
				},
			},
		},
	};

	loading = null;

	defaultAd = {
		sgwpId: 3,
		filedType: "Propagate", // hot广告页
		desc: {
			pName: "hot广告位",
			pWidth: 300,
			pHeight: 750,
			pMaxPage: 5,
		},
	};

	public config: any = {
		sgId: 1,
		showBackPic: 1,
		showType: 1,
		qiKanShowType: 1,
		backPic: "",
		list: [this.defaultAd],
	};

	@Provide()
	shopDisplayTree() {
		return this;
	}

	/**
	 * 商城页分类
	 * @type {ItemObject}
	 */
	public selectTypeToTitle = {
		Swiper: "店铺形象图",
		Site: "店铺信息",
		LabelClass: "分类导航",
		ShowWindow: "商品橱窗",
		Propagate: "广告位",
		search: "搜索",
		Blank: "辅助空白",
		blank: "辅助空白",
		video: "视频",
		ShowWindowGroup: "商品橱窗",
		guide: "引导",
		hoverIcon: "悬浮图标",
	};

	get maxNumber() {
		if (this.config.list && this.config.list.length) {
			return numberToArray(this.config.list[0].desc.pMaxPage);
		} else {
			return [0];
		}
	}

	get getData() {
		switch (this.selectNode.showType) {
			case 2:
				return this.shopData;
			case 3:
				return this.centerData;
			case 9:
				return this.miniData;
			default:
				return [];
		}
	}

	get getFromPage() {
		switch (this.selectNode.showType) {
			case 2:
				return 1;
			case 3:
				return 2;
			case 9:
				return 3;
			default:
				return 0;
		}
	}

	get selected() {
		let result = 0;
		const caseGroup = this.getData.find((v) => {
			return v.isActived && v.fieldType === "ShowWindowGroup";
		});
		if (caseGroup && caseGroup.desc.caseGroup) {
			const key = this.selectNode.showType === 2 ? "sgwpId" : "sgmpId";
			const findResult = caseGroup.desc.caseGroup.find((v) => v[key] === this.selectNode.sgwpId);
			result = findResult ? findResult[key] : 0;
		}
		return result;
	}

	// 方法
	public async mounted() {
		this.loading = this.$loading({
			lock: true,
			text: "请稍等...",
			spinner: "el-icon-loading",
			background: "rgba(225,225,225,0.3)",
		});
	}

	/**
	 * 切换标签
	 * @params null
	 */
	public onPageSwitch(val) {
		this.curPage = val;
	}

	/**
	 * 点击树节点
	 * @params node
	 * 1hot 2商城 3个人中心 4分类 5活动 9微页面
	 */
	public async onNodeClick(node) {
		this.selectNode = node;
		this.themeCode = node.parentId || node.sgId ? await this.getThemeCode(node.parentId || node.sgId) : 1;
		this.loading = this.$loading({
			lock: true,
			text: "请稍等...",
			spinner: "el-icon-loading",
			background: "rgba(225,225,225,0.3)",
		});
		switch (this.selectNode.showType) {
			case 1:
			case 4:
			case 5:
				this.getTableData();
				break;
			case 2:
				this.getShopData(this.selectNode.parentId || this.selectNode.sgId)
					.then((res: any[]) => {
						this.shopData = res.map((i) => {
							i.isActived = (i.sgwpId === node.sgwpId || (i.fieldType === "ShowWindowGroup" && i.desc.caseGroup.some((v) => v.sgwpId === node.sgwpId))) && !!node.sgwpId;
							return i;
						});
						this.$nextTick(() => {
							if (this.$el.querySelector(".is-actived")) {
								this.$el.querySelector(".is-actived").scrollIntoView({ behavior: "smooth", block: "start" });
							}
							this.getTableData();
						});
					})
					.catch((error) => {
						this.loading.close();
					});
				break;
			case 3:
				this.getCenterData(this.selectNode.parentId || this.selectNode.sgId)
					.then((response: any) => {
						this.centerData = response.map((v) => {
							v.isActived = v.sgwpId === node.sgId;
							return v;
						});
						this.$nextTick(() => {
							if (this.$el.querySelector(".is-actived")) {
								this.$el.querySelector(".is-actived").scrollIntoView({ behavior: "smooth", block: "start" });
							}
							this.getTableData();
						});
					})
					.catch((error) => {
						this.loading.close();
					});
				break;
			case 9:
				this.getminiData()
					.then((response) => {
						this.miniData = (response as any).list.map((v) => {
							if (v.fieldType === "Propagate" || v.fieldType === "propagate" || v.fieldType === "ShowWindow" || v.fieldType === "showWindow") {
								v.isActived = v.sgmpId === node.sgwpId;
							} else if (v.fieldType === "ShowWindowGroup" || v.fieldType === "showWindowGroup") {
								const windowCase = v.desc.caseGroup.find((c) => c.sgmpId === node.sgwpId);
								v.isActived = !!windowCase;
							}
							return v;
						});
						this.$nextTick(() => {
							if (this.$el.querySelector(".is-actived")) {
								this.$el.querySelector(".is-actived").scrollIntoView({ behavior: "smooth", block: "start" });
							}
							this.getTableData();
						});
					})
					.catch((error) => {
						this.loading.close();
					});
				break;
			default:
				this.getTableData();
				this.loading.close();
				break;
		}
	}

	/**
	 * 获取商城页示意图数据
	 * @params sgId
	 */
	public getShopData(sgId) {
		return IPSService.decorationMallInfo({ postParams: { sgId } }).then((res: any) => {
			const list = res.list
				.map((v, i) => {
					// 添加网点的默认图片
					// 处理老数据
					if (v.fieldType === "Site") {
						if ((v as NewDisplayShopInfo).desc.siteLogo) {
							(v as NewDisplayShopInfo).desc.siteInfo = {};
							(v as NewDisplayShopInfo).desc.siteInfo.siteLogo = (v as NewDisplayShopInfo).desc.siteLogo;
						}
						if ((v as NewDisplayShopInfo).desc.imageUrl) {
							(v as NewDisplayShopInfo).desc.siteInfo = {};
							(v as NewDisplayShopInfo).desc.siteInfo.siteLogo = (v as NewDisplayShopInfo).desc.imageUrl;
						}
					}
					if (v.fieldType === "Swiper" && !(v as NewDisplayShopBg).desc.imageUrl) {
						(v as NewDisplayShopBg).desc.imageUrl = defaultBg;
					}
					if (i.fieldType === "LabelClass") {
						(i as any).desc.map((i) => {
							i.classPic = defaultImg;
							return i;
						});
					}
					v.isActived = false;
					v._sort = i;
					return v;
				})
				.filter((i) => {
					return Object.keys(this.selectTypeToTitle).includes(i.fieldType);
				});
			return list;
		});
	}

	/**
	 * 获取主题
	 * @params sgId
	 */
	public getThemeCode(sgId) {
		const postParams = { sgId };
		return IPSService.decorationThemeColorInfo({ postParams }).then(
			(res: ItemObject) => {
				return +res.themeCode;
			},
			() => {
				this.$message.error("获取主题失败");
			},
		);
	}

	/**
	 * 获取列表数据
	 * @return null
	 */
	public getTableData() {
		this.postParams = {
			sgId: this.selectNode.parentId,
			sgwpId: this.selectNode.sgwpId,
			keyword: "",
			page: 1,
			pageSize: 10,
			pageId: this.selectNode.pageId || 0,
			parentId: this.selectNode.parentId,
			sgName: this.selectNode.sgwpName || "",
			pWidth: this.selectNode.pWidth,
			pHeight: this.selectNode.pHeight,
		};
	}

	/**
	 * 获取个人中心示意图数据
	 * @params sgId
	 */
	public getCenterData(sgId) {
		return IPSService.getMemberCenterInfo({
			postParams: {
				sgId,
			},
		}).then((response) => {
			return response.list;
		});
	}

	// 获取展示样式的配置
	public getConfig() {
		IPSService.decorationThemeHotInfo({
			postParams: { sgId: this.selectNode.parentId },
		}).then((res) => {
			this.config = res;
		});
	}

	// 获取微页面配置
	public getminiData() {
		if (this.selectNode.pageId) {
			return IPSService.miniPageInfo({
				postParams: {
					pageId: this.selectNode.pageId,
				},
			}).then((res) => {
				this.miniPage.desc = Object.assign(
					this.miniPage.desc,
					{ buttonInfo: isEmpty(res.buttonInfo) ? this.miniPage.desc.buttonInfo : res.buttonInfo },
					{
						showButton: !!res.showButton,
						val: res.val,
						pageName: res.pageName,
					},
				);
				res.list.unshift(this.miniPage);
				return res;
			});
		} else {
			return new Promise((resolve, reject) => {
				resolve([]);
			});
		}
	}

	/**
	 * 关闭loading
	 */
	public loadingClose() {
		if (this.loading) {
			this.loading.close();
		}
	}
}
